import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@ngneat/reactive-forms';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'bs-dialog-observation',
  templateUrl: './dialog-observation.component.html',
  styleUrls: ['./dialog-observation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogObservationComponent implements OnInit {
  observation: FormControl<string> = new FormControl();
  ambiente: FormControl<string> = new FormControl();
  ambientesComplete!: Set<string>;
  filteredOptions!: Observable<string[]>;
  isEditable!: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      observacao: {
        ambiente: string;
        observacao: string;
      };
      ambientes: string[];
      isEditable: boolean;
    },
    private readonly dialogRef: MatDialogRef<DialogObservationComponent>
  ) {}

  ngOnInit() {
    this.observation.setValue(this.data.observacao.observacao);
    this.ambiente.setValue(this.data.observacao.ambiente);
    this.isEditable = this.data.isEditable;
    this.ambientesComplete = new Set(this.data.ambientes);
    this.filteredOptions = this.ambiente.valueChanges.pipe(
      startWith(this.ambiente.value),
      map((value) => this._filter(value || ''))
    );
  }

  _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    const setToArray = Array.from(this.ambientesComplete);

    return setToArray.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  sendObservation() {
    this.dialogRef.close({
      isSaved: true,
      value: this.observation.value,
      ambiente: this.ambiente.value,
    });
  }
}
